import React from 'react';
import { IHistorischeStatistieken } from '../models/page';
import HistoryStatsCards from './history-stats-cards';

export interface IBronzenTableProps {
	results: IHistorischeStatistieken;
}

export default function BronzenTable({ results }: IBronzenTableProps) {
	return (
		<>
			<HistoryStatsCards schilden={results.bronzenSchilden.schilden} />
		</>
	);
}
